import React from 'react'
import"./Banner.css"

function Banner() {
  return (
    <div className="caption">
      <div className="totaltext">
        <div>
          <p className="textfirst">SIMPLE RECEPIS MADE FOR </p>
        </div>
        <div>
          <p className="textsecond"> real, actual, everyday life. </p>
        </div>
      </div>
    </div>
  );
}

export default Banner